import type { HeroImageGridVariant } from "./HeroImageGrid";

type Params = {
  pictures: string[];
  variant?: HeroImageGridVariant;
  onClick?: () => void;
  onTileClick?: (index: number) => void;
};

export function useHeroImageGrid({
  pictures,
  variant = "compact",
  onClick,
  onTileClick,
}: Params) {
  const maxTiles = variant === "compact" ? 3 : 5;
  const totalPhotos = pictures.length;
  const morePhotos =
    totalPhotos > maxTiles ? totalPhotos - (maxTiles - 1) : 0;
  const isSingle = totalPhotos === 1;
  const onlyTwo = totalPhotos === 2;
  const isEmpty = totalPhotos === 0;

  const tileClickFor = (i: number) =>
    onTileClick ? () => onTileClick(i) : undefined;
  const containerOnClick = onTileClick ? undefined : onClick;
  const tileCursor = onTileClick ? "cursor-pointer" : "";
  const containerCursor = containerOnClick ? "cursor-pointer" : "";

  return {
    maxTiles,
    totalPhotos,
    morePhotos,
    isSingle,
    onlyTwo,
    isEmpty,
    tileClickFor,
    containerOnClick,
    tileCursor,
    containerCursor,
  };
}
